import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';

import { InlineGrid, InlineGridField } from '@components/form';
import ticketsCheckedColumns from '@modules/tickets/_ticketsColumns';

const View: React.SFC<any> = _props => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col className="grid-system-margin" />
      </Row>
      <Row>
        <Col md={12}>
          <Row className="without-min-width">
            <Col md={12}>
              <InlineGridField
                component={InlineGrid}
                adding={false}
                filtering={false}
                ignoreLocalStorage={true}
                name="checkedItems"
                columns={ticketsCheckedColumns}
                style={{ height: '50vh', overflow: 'auto' }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col className="grid-system-margin" />
      </Row>
    </Grid>
    <Divider />
  </div>
);

export const TicketsCancelFormBasic = View;



// WEBPACK FOOTER //
// ./src/modules/tickets/TicketsCancelFormBasic.tsx